import * as React from 'react';
const SvgIcon = props => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill={props.fill || '#fff'} viewBox="0 -960 960 960">
      <path d="M180-140v-450l300-225.77L780-590v450H556.15v-267.69h-152.3V-140z"></path>
    </svg>;
};
export default React.memo(SvgIcon);